import { useCallback } from 'react';

export const useKeyboardNavigation = ({
  suggestions,
  isOpen,
  selectedIndex,
  setIsOpen,
  setSelectedIndex,
  handleSuggestionClick,
  inputRef,
}) => {
  return useCallback(
    (e) => {
      if (!isOpen) {
        if (e.key === 'ArrowDown' && suggestions.length > 0) {
          setIsOpen(true);
          setSelectedIndex(0);
          e.preventDefault();
        }
        return;
      }

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          setSelectedIndex((prevIndex) =>
            prevIndex < suggestions.length - 1 ? prevIndex + 1 : prevIndex
          );
          break;
        case 'ArrowUp':
          e.preventDefault();
          setSelectedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : -1));
          break;
        case 'Enter':
          e.preventDefault();
          if (selectedIndex >= 0) {
            handleSuggestionClick(suggestions[selectedIndex]);
          }
          break;
        case 'Escape':
          e.preventDefault();
          setIsOpen(false);
          setSelectedIndex(-1);
          inputRef.current?.blur();
          break;
        case 'Tab':
          setIsOpen(false);
          setSelectedIndex(-1);
          break;
        default:
          break;
      }
    },
    [
      suggestions,
      isOpen,
      selectedIndex,
      setIsOpen,
      setSelectedIndex,
      handleSuggestionClick,
      inputRef,
    ]
  );
};
